import { render, staticRenderFns } from "./studentCategoryMapping.vue?vue&type=template&id=6c9d51f3&scoped=true"
import script from "./studentCategoryMapping.vue?vue&type=script&lang=js"
export * from "./studentCategoryMapping.vue?vue&type=script&lang=js"
import style0 from "./studentCategoryMapping.vue?vue&type=style&index=0&id=6c9d51f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d51f3",
  null
  
)

export default component.exports